import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Button, Text } from '@reveni-io/reveni-ui'

import { formatOrderDate, getProductCountLabel } from '@/helpers'

import useVisibleOrders from '../hooks/useVisibleOrders/useVisibleOrders'
import OrderRowIcon from './OrderRowIcon/OrderRowIcon'
import * as Styles from './styles'

const RecoveredOrdersList = ({ orders, onSelectOrder, isSelecting, selectedOrderNumber }) => {
  const { t, i18n } = useTranslation()
  const theme = useTheme()
  const { visibleOrders, hasHiddenOrders, showAllOrders } = useVisibleOrders(orders)

  return (
    <Styles.Container>
      <Styles.List>
        {visibleOrders.map(order => (
          <Styles.OrderRow key={order.number} type="button" disabled={isSelecting} onClick={() => onSelectOrder(order)}>
            <Styles.OrderInfo>
              <Styles.OrderHeading>
                <Text tag="span" type="titleS" color={theme.title.primary}>
                  {order.number}
                </Text>
                <Styles.OrderDate tag="span" type="bodySRegular" color={theme.colors.grey.tone700}>
                  {formatOrderDate(order.order_date, i18n.language)}
                </Styles.OrderDate>
              </Styles.OrderHeading>
              <Text tag="span" type="bodyMRegular">
                {getProductCountLabel(t, order.product_count)}
              </Text>
            </Styles.OrderInfo>
            <OrderRowIcon loading={isSelecting && order.number === selectedOrderNumber} />
          </Styles.OrderRow>
        ))}
      </Styles.List>
      {hasHiddenOrders && (
        <Button variant="text" fullWidth onClick={showAllOrders}>
          {t('Ver más')}
        </Button>
      )}
    </Styles.Container>
  )
}

export default RecoveredOrdersList
